<div class="w-full flex mb-5" *ngIf="allowLegend">
    <div *ngFor="let item of data; let i = index" class="flex align-items-center mr-4 legend">
        <div class="border-circle border-2 label" [style.border-color]="colors[i]"></div>

        <div [style.color]="colors[i]" class="ml-2 title">
            {{ columns[i] }}
        </div>
    </div>
</div>
<div class="content">
    <p-chart (mouseout)="display='none'" type="bar"  width="calc(100% - 2rem)" height="230px" [data]="basicData" [options]="basicOptions"></p-chart>
    <div id="tooltip" [style.display]="display" [style.left]="leftpos" [style.top]="rightpos">
        <div *ngIf="!tooltipTemplate">
            <p [style.color]="color">
                {{activedText.title | date: "dd.MM.yyyy"}}
            </p>
            <span>
                <ng-container *ngIf="disableCurrency == false">
                    {{activedText.subtitle | currency: 'BRL'}}
                </ng-container>

                <ng-container *ngIf="disableCurrency == true">
                   Total: {{activedText.subtitle }}
                </ng-container>
                
            </span>
        </div>
        <div *ngIf="tooltipTemplate">
            <ng-template [ngTemplateOutlet]="tooltipTemplate"
            [ngTemplateOutletContext]="{
                fullData: fullData,
                activedText: activedText,
                colors:colors
            }"
            ></ng-template>
        </div>
    </div>
</div>
